import React from 'react';
import './../index.css';
import packageJson from '../../package.json';

export class LevelFooter extends React.Component {

  render() {
    let text="Version: " + packageJson.version;
      return (
        <>
          {
            /*
              * text section
              */
          }
          <div className='levelFooter'>
              {text}
          </div>
        </>
      );
  }


}
